export const YT_LIVE_E2E_PREFIX = 'yt-live';
export const PRODUCTS_MIN_COUNT = 1;
export const PRODUCTS_MAX_COUNT = 300;
